<template>
  <NCard
    aria-modal="true"
    :bordered="false"
    class="c-timeline-modal absolute z-400 bottom-8 -right-[300px] pa-4 w-[300px] shadow-2xl rounded-lg bg-primary6"
    closable
    embedded
    role="dialog"
    :style="{
      '--n-padding-top': 0,
      '--n-padding-right': 0,
      '--n-padding-bottom': 0,
      '--n-padding-left': 0,
    }"
    @close="emit('close')"
  >
    <template #header>
      <div class="pb-4">{{ t('canvasUI.canvasBuilder.components.history.log') }}</div>
    </template>

    <CTimeline
      :class="{
        'overflow-auto max-h-[500px]': data.length > 8,
      }"
      :data="data"
      @item-activated="(item) => emit('item-activated', item)"
    />
  </NCard>
</template>

<script lang="ts" setup>
import { NCard } from 'naive-ui'
import { useI18n } from 'vue-i18n'

import CTimeline, { type ExtendedTimelineItemProps } from '@lib/components/CTimeline/CTimeline.vue'

const { t } = useI18n()

defineProps<{
  data: ExtendedTimelineItemProps[]
}>()

const emit = defineEmits<{ close: []; 'item-activated': [i: ExtendedTimelineItemProps] }>()
</script>
<style scoped>
.c-timeline-modal :deep(.n-card-header) {
  align-items: flex-start;
}
</style>
